import { render } from "./HotspotsIn3DSpace.vue?vue&type=template&id=511b0d6d"
import script from "./HotspotsIn3DSpace.vue?vue&type=script&lang=js"
export * from "./HotspotsIn3DSpace.vue?vue&type=script&lang=js"

import "./HotspotsIn3DSpace.vue?vue&type=style&index=0&id=511b0d6d&lang=css"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\state-of-green-value-chains\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__